export default "__VITE_ASSET__Dt31X4Q9__"